import { LocaleService } from '../services/locale.service';

export type ThematicField = 'name' | 'title' | 'resume';

/**
 * Talker front keeps EN thematic copy in static i18n (not DB).
 * Same overlay for Sherpa PWA when UI lang is English.
 */
export function translateThematicField(
  locale: LocaleService,
  slug: string | undefined,
  field: ThematicField,
  fallback: string,
): string {
  if (!slug || locale.lang !== 'en') {
    return fallback;
  }

  const key = `thematics.catalog.${slug}.${field}`;
  const value = locale.instant(key);
  return value !== key ? value : fallback;
}
